import { darken } from '@savgroup-front-common/primitive/helpers/cssColor';
import { SUPPORTED_PROPERTIES } from '@savgroup-front-common/types';

export default {
  [SUPPORTED_PROPERTIES.COLOR]: {
    fallback: `components.defaultButtons.${SUPPORTED_PROPERTIES.COLOR}`,
  },
  [SUPPORTED_PROPERTIES.BACKGROUND_COLOR]: {
    fallback: 'colors.success',
  },
  [SUPPORTED_PROPERTIES.ON_HOVER_BACKGROUND_COLOR]: {
    value: darken(0.075, '#0BB07B'),
  },
  [SUPPORTED_PROPERTIES.DISABLED_COLOR]: {
    fallback: `components.defaultButtons.${SUPPORTED_PROPERTIES.DISABLED_COLOR}`,
  },
  [SUPPORTED_PROPERTIES.DISABLED_BACKGROUND_COLOR]: {
    fallback: `components.defaultButtons.${SUPPORTED_PROPERTIES.DISABLED_BACKGROUND_COLOR}`,
  },
};
